import { Check, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { formatAmount } from '../money';
import { checkTotals, type ExpenseForm } from './form-model';

/** The live totals check (design §1.3, §2.3): «Il totale torna», or by how much it is off. */
export function TotalsLine({ form }: { readonly form: ExpenseForm }) {
  const { t } = useTranslation('expenses');
  const check = checkTotals(form);
  if (check.kind === 'no-total') return null;
  if (check.kind === 'ok') {
    return (
      <p role="status" className="flex items-center gap-1 text-sm text-success">
        <Check aria-hidden="true" className="size-4" />
        {t('capture.totals.ok')}
      </p>
    );
  }
  return (
    <p role="status" className="flex items-start gap-1 text-sm text-destructive">
      <TriangleAlert aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
      {check.kind === 'invalid'
        ? t('capture.totals.invalid')
        : t('capture.totals.mismatch', {
            difference: formatAmount(check.difference),
            sum: formatAmount(check.sum),
            total: formatAmount(check.total),
          })}
    </p>
  );
}
